import {flatMap, flatten, values} from "lodash";

const matchedTypes = [
    {
        extension: 'abs',
        mimeTypes: [
            'audio/x-mpeg'
        ]
    },
    {
        extension: 'ai',
        mimeTypes: [
            'application/postscript'
        ]
    },
    {
        extension: 'aif',
        mimeTypes: [
            'audio/x-aiff'
        ]
    },
    {
        extension: 'aifc',
        mimeTypes: [
            'audio/x-aiff'
        ]
    },
    {
        extension: 'aiff',
        mimeTypes: [
            'audio/x-aiff'
        ]
    },
    {
        extension: 'aim',
        mimeTypes: [
            'application/x-aim'
        ]
    },
    {
        extension: 'art',
        mimeTypes: [
            'image/x-jg'
        ]
    },
    {
        extension: 'asf',
        mimeTypes: [
            'video/x-ms-asf'
        ]
    },
    {
        extension: 'asx',
        mimeTypes: [
            'video/x-ms-asf'
        ]
    },
    {
        extension: 'au',
        mimeTypes: [
            'audio/basic'
        ]
    },
    {
        extension: 'avi',
        mimeTypes: [
            'video/x-msvideo'
        ]
    },
    {
        extension: 'avx',
        mimeTypes: [
            'video/x-rad-screenplay'
        ]
    },
    {
        extension: 'bcpio',
        mimeTypes: [
            'application/x-bcpio'
        ]
    },
    {
        extension: 'bin',
        mimeTypes: [
            'application/octet-stream'
        ]
    },
    {
        extension: 'bmp',
        mimeTypes: [
            'image/bmp'
        ]
    },
    {
        extension: 'body',
        mimeTypes: [
            'text/html'
        ]
    },
    {
        extension: 'cdf',
        mimeTypes: [
            'application/x-cdf'
        ]
    },
    {
        extension: 'cer',
        mimeTypes: [
            'application/pkix-cert'
        ]
    },
    {
        extension: 'class',
        mimeTypes: [
            'application/java'
        ]
    },
    {
        extension: 'cpio',
        mimeTypes: [
            'application/x-cpio'
        ]
    },
    {
        extension: 'csh',
        mimeTypes: [
            'application/x-csh'
        ]
    },
    {
        extension: 'css',
        mimeTypes: [
            'text/css'
        ]
    },
    {
        extension: 'dib',
        mimeTypes: [
            'image/bmp'
        ]
    },
    {
        extension: 'doc',
        mimeTypes: [
            'application/msword'
        ]
    },
    {
        extension: 'dtd',
        mimeTypes: [
            'application/xml-dtd'
        ]
    },
    {
        extension: 'dv',
        mimeTypes: [
            'video/x-dv'
        ]
    },
    {
        extension: 'dvi',
        mimeTypes: [
            'application/x-dvi'
        ]
    },
    {
        extension: 'eot',
        mimeTypes: [
            'application/vnd.ms-fontobject'
        ]
    },
    {
        extension: 'eps',
        mimeTypes: [
            'application/postscript'
        ]
    },
    {
        extension: 'etx',
        mimeTypes: [
            'text/x-setext'
        ]
    },
    {
        extension: 'exe',
        mimeTypes: [
            'application/octet-stream'
        ]
    },
    {
        extension: 'gif',
        mimeTypes: [
            'image/gif'
        ]
    },
    {
        extension: 'gtar',
        mimeTypes: [
            'application/x-gtar'
        ]
    },
    {
        extension: 'gz',
        mimeTypes: [
            'application/x-gzip'
        ]
    },
    {
        extension: 'hdf',
        mimeTypes: [
            'application/x-hdf'
        ]
    },
    {
        extension: 'hqx',
        mimeTypes: [
            'application/mac-binhex40'
        ]
    },
    {
        extension: 'htc',
        mimeTypes: [
            'text/x-component'
        ]
    },
    {
        extension: 'htm',
        mimeTypes: [
            'text/html'
        ]
    },
    {
        extension: 'html',
        mimeTypes: [
            'text/html'
        ]
    },
    {
        extension: 'ief',
        mimeTypes: [
            'image/ief'
        ]
    },
    {
        extension: 'jad',
        mimeTypes: [
            'text/vnd.sun.j2me.app-descriptor'
        ]
    },
    {
        extension: 'jar',
        mimeTypes: [
            'application/java-archive'
        ]
    },
    {
        extension: 'java',
        mimeTypes: [
            'text/x-java-source'
        ]
    },
    {
        extension: 'jnlp',
        mimeTypes: [
            'application/x-java-jnlp-file'
        ]
    },
    {
        extension: 'jpe',
        mimeTypes: [
            'image/jpeg'
        ]
    },
    {
        extension: 'jpeg',
        mimeTypes: [
            'image/jpeg'
        ]
    },
    {
        extension: 'jpg',
        mimeTypes: [
            'image/jpeg'
        ]
    },
    {
        extension: 'js',
        mimeTypes: [
            'application/javascript'
        ]
    },
    {
        extension: 'jsf',
        mimeTypes: [
            'text/plain'
        ]
    },
    {
        extension: 'json',
        mimeTypes: [
            'application/json'
        ]
    },
    {
        extension: 'jspf',
        mimeTypes: [
            'text/plain'
        ]
    },
    {
        extension: 'kar',
        mimeTypes: [
            'audio/midi'
        ]
    },
    {
        extension: 'latex',
        mimeTypes: [
            'application/x-latex'
        ]
    },
    {
        extension: 'm3u',
        mimeTypes: [
            'audio/x-mpegurl'
        ]
    },
    {
        extension: 'mac',
        mimeTypes: [
            'image/x-macpaint'
        ]
    },
    {
        extension: 'man',
        mimeTypes: [
            'text/troff'
        ]
    },
    {
        extension: 'mathml',
        mimeTypes: [
            'application/mathml+xml'
        ]
    },
    {
        extension: 'me',
        mimeTypes: [
            'text/troff'
        ]
    },
    {
        extension: 'mid',
        mimeTypes: [
            'audio/midi'
        ]
    },
    {
        extension: 'midi',
        mimeTypes: [
            'audio/midi'
        ]
    },
    {
        extension: 'mif',
        mimeTypes: [
            'application/x-mif'
        ]
    },
    {
        extension: 'mov',
        mimeTypes: [
            'video/quicktime'
        ]
    },
    {
        extension: 'movie',
        mimeTypes: [
            'video/x-sgi-movie'
        ]
    },
    {
        extension: 'mp1',
        mimeTypes: [
            'audio/mpeg'
        ]
    },
    {
        extension: 'mp2',
        mimeTypes: [
            'audio/mpeg'
        ]
    },
    {
        extension: 'mp3',
        mimeTypes: [
            'audio/mpeg'
        ]
    },
    {
        extension: 'mp4',
        mimeTypes: [
            'video/mp4'
        ]
    },
    {
        extension: 'mpa',
        mimeTypes: [
            'audio/mpeg'
        ]
    },
    {
        extension: 'mpe',
        mimeTypes: [
            'video/mpeg'
        ]
    },
    {
        extension: 'mpeg',
        mimeTypes: [
            'video/mpeg'
        ]
    },
    {
        extension: 'mpega',
        mimeTypes: [
            'audio/x-mpeg'
        ]
    },
    {
        extension: 'mpg',
        mimeTypes: [
            'video/mpeg'
        ]
    },
    {
        extension: 'mpv2',
        mimeTypes: [
            'video/mpeg2'
        ]
    },
    {
        extension: 'ms',
        mimeTypes: [
            'application/x-wais-source'
        ]
    },
    {
        extension: 'nc',
        mimeTypes: [
            'application/x-netcdf'
        ]
    },
    {
        extension: 'oda',
        mimeTypes: [
            'application/oda'
        ]
    },
    {
        extension: 'odb',
        mimeTypes: [
            'application/vnd.oasis.opendocument.database'
        ]
    },
    {
        extension: 'odc',
        mimeTypes: [
            'application/vnd.oasis.opendocument.chart'
        ]
    },
    {
        extension: 'odf',
        mimeTypes: [
            'application/vnd.oasis.opendocument.formula'
        ]
    },
    {
        extension: 'odg',
        mimeTypes: [
            'application/vnd.oasis.opendocument.graphics'
        ]
    },
    {
        extension: 'odi',
        mimeTypes: [
            'application/vnd.oasis.opendocument.image'
        ]
    },
    {
        extension: 'odm',
        mimeTypes: [
            'application/vnd.oasis.opendocument.text-master'
        ]
    },
    {
        extension: 'odp',
        mimeTypes: [
            'application/vnd.oasis.opendocument.presentation'
        ]
    },
    {
        extension: 'ods',
        mimeTypes: [
            'application/vnd.oasis.opendocument.spreadsheet'
        ]
    },
    {
        extension: 'odt',
        mimeTypes: [
            'application/vnd.oasis.opendocument.text'
        ]
    },
    {
        extension: 'otg',
        mimeTypes: [
            'application/vnd.oasis.opendocument.graphics-template'
        ]
    },
    {
        extension: 'oth',
        mimeTypes: [
            'application/vnd.oasis.opendocument.text-web'
        ]
    },
    {
        extension: 'otp',
        mimeTypes: [
            'application/vnd.oasis.opendocument.presentation-template'
        ]
    },
    {
        extension: 'ots',
        mimeTypes: [
            'application/vnd.oasis.opendocument.spreadsheet-template'
        ]
    },
    {
        extension: 'ott',
        mimeTypes: [
            'application/vnd.oasis.opendocument.text-template'
        ]
    },
    {
        extension: 'ogx',
        mimeTypes: [
            'application/ogg'
        ]
    },
    {
        extension: 'ogv',
        mimeTypes: [
            'video/ogg'
        ]
    },
    {
        extension: 'oga',
        mimeTypes: [
            'audio/ogg'
        ]
    },
    {
        extension: 'ogg',
        mimeTypes: [
            'audio/ogg'
        ]
    },
    {
        extension: 'otf',
        mimeTypes: [
            'application/x-font-opentype'
        ]
    },
    {
        extension: 'spx',
        mimeTypes: [
            'audio/ogg'
        ]
    },
    {
        extension: 'flac',
        mimeTypes: [
            'audio/flac'
        ]
    },
    {
        extension: 'anx',
        mimeTypes: [
            'application/annodex'
        ]
    },
    {
        extension: 'axa',
        mimeTypes: [
            'audio/annodex'
        ]
    },
    {
        extension: 'axv',
        mimeTypes: [
            'video/annodex'
        ]
    },
    {
        extension: 'xspf',
        mimeTypes: [
            'application/xspf+xml'
        ]
    },
    {
        extension: 'pbm',
        mimeTypes: [
            'image/x-portable-bitmap'
        ]
    },
    {
        extension: 'pct',
        mimeTypes: [
            'image/pict'
        ]
    },
    {
        extension: 'pdf',
        mimeTypes: [
            'application/pdf'
        ]
    },
    {
        extension: 'pgm',
        mimeTypes: [
            'image/x-portable-graymap'
        ]
    },
    {
        extension: 'pic',
        mimeTypes: [
            'image/pict'
        ]
    },
    {
        extension: 'pict',
        mimeTypes: [
            'image/pict'
        ]
    },
    {
        extension: 'pls',
        mimeTypes: [
            'audio/x-scpls'
        ]
    },
    {
        extension: 'png',
        mimeTypes: [
            'image/png'
        ]
    },
    {
        extension: 'pnm',
        mimeTypes: [
            'image/x-portable-anymap'
        ]
    },
    {
        extension: 'pnt',
        mimeTypes: [
            'image/x-macpaint'
        ]
    },
    {
        extension: 'ppm',
        mimeTypes: [
            'image/x-portable-pixmap'
        ]
    },
    {
        extension: 'ppt',
        mimeTypes: [
            'application/vnd.ms-powerpoint'
        ]
    },
    {
        extension: 'pps',
        mimeTypes: [
            'application/vnd.ms-powerpoint'
        ]
    },
    {
        extension: 'ps',
        mimeTypes: [
            'application/postscript'
        ]
    },
    {
        extension: 'psd',
        mimeTypes: [
            'image/vnd.adobe.photoshop'
        ]
    },
    {
        extension: 'qt',
        mimeTypes: [
            'video/quicktime'
        ]
    },
    {
        extension: 'qti',
        mimeTypes: [
            'image/x-quicktime'
        ]
    },
    {
        extension: 'qtif',
        mimeTypes: [
            'image/x-quicktime'
        ]
    },
    {
        extension: 'ras',
        mimeTypes: [
            'image/x-cmu-raster'
        ]
    },
    {
        extension: 'rdf',
        mimeTypes: [
            'application/rdf+xml'
        ]
    },
    {
        extension: 'rgb',
        mimeTypes: [
            'image/x-rgb'
        ]
    },
    {
        extension: 'rm',
        mimeTypes: [
            'application/vnd.rn-realmedia'
        ]
    },
    {
        extension: 'roff',
        mimeTypes: [
            'text/troff'
        ]
    },
    {
        extension: 'rtf',
        mimeTypes: [
            'application/rtf'
        ]
    },
    {
        extension: 'rtx',
        mimeTypes: [
            'text/richtext'
        ]
    },
    {
        extension: 'sfnt',
        mimeTypes: [
            'application/font-sfnt'
        ]
    },
    {
        extension: 'sh',
        mimeTypes: [
            'application/x-sh'
        ]
    },
    {
        extension: 'shar',
        mimeTypes: [
            'application/x-shar'
        ]
    },
    {
        extension: 'sit',
        mimeTypes: [
            'application/x-stuffit'
        ]
    },
    {
        extension: 'snd',
        mimeTypes: [
            'audio/basic'
        ]
    },
    {
        extension: 'src',
        mimeTypes: [
            'application/x-wais-source'
        ]
    },
    {
        extension: 'sv4cpio',
        mimeTypes: [
            'application/x-sv4cpio'
        ]
    },
    {
        extension: 'sv4crc',
        mimeTypes: [
            'application/x-sv4crc'
        ]
    },
    {
        extension: 'svg',
        mimeTypes: [
            'image/svg+xml'
        ]
    },
    {
        extension: 'svgz',
        mimeTypes: [
            'image/svg+xml'
        ]
    },
    {
        extension: 'swf',
        mimeTypes: [
            'application/x-shockwave-flash'
        ]
    },
    {
        extension: 't',
        mimeTypes: [
            'text/troff'
        ]
    },
    {
        extension: 'tar',
        mimeTypes: [
            'application/x-tar'
        ]
    },
    {
        extension: 'tcl',
        mimeTypes: [
            'application/x-tcl'
        ]
    },
    {
        extension: 'tex',
        mimeTypes: [
            'application/x-tex'
        ]
    },
    {
        extension: 'texi',
        mimeTypes: [
            'application/x-texinfo'
        ]
    },
    {
        extension: 'texinfo',
        mimeTypes: [
            'application/x-texinfo'
        ]
    },
    {
        extension: 'tif',
        mimeTypes: [
            'image/tiff'
        ]
    },
    {
        extension: 'tiff',
        mimeTypes: [
            'image/tiff'
        ]
    },
    {
        extension: 'tr',
        mimeTypes: [
            'text/troff'
        ]
    },
    {
        extension: 'tsv',
        mimeTypes: [
            'text/tab-separated-values'
        ]
    },
    {
        extension: 'ttf',
        mimeTypes: [
            'application/x-font-ttf'
        ]
    },
    {
        extension: 'txt',
        mimeTypes: [
            'text/plain'
        ]
    },
    {
        extension: 'ulw',
        mimeTypes: [
            'audio/basic'
        ]
    },
    {
        extension: 'ustar',
        mimeTypes: [
            'application/x-ustar'
        ]
    },
    {
        extension: 'vxml',
        mimeTypes: [
            'application/voicexml+xml'
        ]
    },
    {
        extension: 'xbm',
        mimeTypes: [
            'image/x-xbitmap'
        ]
    },
    {
        extension: 'xht',
        mimeTypes: [
            'application/xhtml+xml'
        ]
    },
    {
        extension: 'xhtml',
        mimeTypes: [
            'application/xhtml+xml'
        ]
    },
    {
        extension: 'xls',
        mimeTypes: [
            'application/vnd.ms-excel'
        ]
    },
    {
        extension: 'xml',
        mimeTypes: [
            'application/xml'
        ]
    },
    {
        extension: 'xpm',
        mimeTypes: [
            'image/x-xpixmap'
        ]
    },
    {
        extension: 'xsl',
        mimeTypes: [
            'application/xml'
        ]
    },
    {
        extension: 'xslt',
        mimeTypes: [
            'application/xslt+xml'
        ]
    },
    {
        extension: 'xul',
        mimeTypes: [
            'application/vnd.mozilla.xul+xml'
        ]
    },
    {
        extension: 'xwd',
        mimeTypes: [
            'image/x-xwindowdump'
        ]
    },
    {
        extension: 'vsd',
        mimeTypes: [
            'application/vnd.visio'
        ]
    },
    {
        extension: 'wav',
        mimeTypes: [
            'audio/x-wav'
        ]
    },
    {
        extension: 'wbmp',
        mimeTypes: [
            'image/vnd.wap.wbmp'
        ]
    },
    {
        extension: 'wml',
        mimeTypes: [
            'text/vnd.wap.wml'
        ]
    },
    {
        extension: 'wmlc',
        mimeTypes: [
            'application/vnd.wap.wmlc'
        ]
    },
    {
        extension: 'wmls',
        mimeTypes: [
            'text/vnd.wap.wmlsc'
        ]
    },
    {
        extension: 'wmlscriptc',
        mimeTypes: [
            'application/vnd.wap.wmlscriptc'
        ]
    },
    {
        extension: 'wmv',
        mimeTypes: [
            'video/x-ms-wmv'
        ]
    },
    {
        extension: 'woff',
        mimeTypes: [
            'application/font-woff'
        ]
    },
    {
        extension: 'woff2',
        mimeTypes: [
            'application/font-woff2'
        ]
    },
    {
        extension: 'wrl',
        mimeTypes: [
            'model/vrml'
        ]
    },
    {
        extension: 'wspolicy',
        mimeTypes: [
            'application/wspolicy+xml'
        ]
    },
    {
        extension: 'z',
        mimeTypes: [
            'application/x-compress'
        ]
    },
    {
        extension: 'zip',
        mimeTypes: [
            'application/zip'
        ]
    },
    {
        extension: 'hwp',
        mimeTypes: [
            'application/vnd.hancom.hwp',
            'application/haansofthwp',
            'application/x-hwp',
        ]
    },
]

const acceptedFiles = {
    image: ['jpeg', 'jpg', 'gif', 'png'],
    video: ['mp4', 'mov', 'wmv', 'avi'],
    audio: ['mp3', 'wav', 'm4a'],
    docs: ['zip', 'hwp', 'pptx', 'ppt', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'rar', 'ace', 'alx', 'egg', 'pdf'],
};

const getAcceptedImageMimeTypes = (exportType?:'string' | 'object') => {
    const acceptedExtensions = acceptedFiles.image || [];
    const mimeTypes = matchedTypes || [];

    const acceptedMimeTypes = flatMap(mimeTypes.filter(o => acceptedExtensions.includes(o.extension)), o => o.mimeTypes)

    return exportType === 'string' ? acceptedMimeTypes.join(',') : acceptedMimeTypes;
}

type FileTypes = 'image' | 'video' | 'audio' | 'docs';
const getAcceptedFileMimeTypes = (fileTypes:FileTypes[] | 'all', exportType?:'string' | 'object') => {
    let acceptedExtensions = fileTypes === 'all' ? flatten(values(acceptedFiles)) : [];

    if (typeof fileTypes === 'object' && !!fileTypes?.length) fileTypes.forEach(item => {
        acceptedExtensions = acceptedExtensions.concat(acceptedFiles[item])
    })

    const mimeTypes = matchedTypes || [];

    const acceptedMimeTypes = flatMap(mimeTypes.filter(o => acceptedExtensions.includes(o.extension)), o => o.mimeTypes)

    return exportType === 'string' ? acceptedMimeTypes.join(',') : acceptedMimeTypes;
}

export {
    acceptedFiles,
    getAcceptedImageMimeTypes,
    getAcceptedFileMimeTypes,
}

export default acceptedFiles;